if (!customElements.get('teaser-element')) {
  customElements.define('teaser-element', class TeaserElement extends HTMLElement {
    constructor() {
      super();
      const teaserElements = this.querySelectorAll('.teaser-card');
      teaserElements.forEach(element => {
        element.addEventListener('mouseenter', this.toggleExpand.bind(element, true));
        element.addEventListener('mouseleave', this.toggleExpand.bind(element, false));
      });
    }

    toggleExpand(expand) {
      if (expand) {
        this.classList.add('expanded');
      } else {
        this.classList.remove('expanded');
      }
    }
  });
}
